// extracted by mini-css-extract-plugin
module.exports = {"camTimeout":"CamTimeout_camTimeout__tALXF","message":"CamTimeout_message__FVJt4","button":"CamTimeout_button__RzWkZ"};